import UpgradeMembership from "../components/membershipUpgrade/main";

const MembershipUpgrade = () => {
  return <UpgradeMembership />;
};

export default MembershipUpgrade;
